import React from "react";

import PhotoCover from '../../Theme1/Cover/PhotoCover';
import NoPhotoCover from './NoPhotoCover'
import CoverController from "../../common/CoverController";
import './cover.css'

const Cover = ({ details, photoMode }) => {
  return (
    <CoverController
      details={details}
      photoMode={photoMode}
      PhotoComponent={PhotoCover}
      NoPhotoComponent={NoPhotoCover}
    />
  );
};

export default Cover;